import React, { useEffect } from "react";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import useCalendarSale from "../../CalendarSale/hooks/useCalendarSale";
import SingleAvailAbleExercise from "../../CalendarSale/single-exercise";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import CourtGrid from "../../CourtGrid";
import WeeklyGrid from "../../WeeklyGrid";

interface IProps {
  saleStep: SaleStep;
}

const CalendarSaleModule: React.FC<IProps> = ({ saleStep }) => {
  const { getExercisesAvailable, exerciseAvailAble, loading } = useCalendarSale();

  useEffect(() => {
    getExercisesAvailable(saleStep.exerciseName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const highlightedFeatures = [
    saleStep.highlightedFeature1,
    saleStep.highlightedFeature2,
    saleStep.highlightedFeature3,
  ].filter(Boolean);

  if (loading) return <EASkeletonLoader height="200px" />;

  // Sprawdzamy czy pokazać siatkę kortów czy standardową listę
  if (saleStep.courtGridScheduleVariant === true) {
    return <CourtGrid saleStep={saleStep} />;
  }

  // Sprawdzamy czy pokazać siatkę tygodniową
  if (saleStep.weeklyGridScheduleVariant === true) {
    return <WeeklyGrid saleStep={saleStep} />;
  }

  // Standardowa logika - lista SingleAvailAbleExercise
  if (exerciseAvailAble.length > 0)
    return (
      <div className="module-list">
        {exerciseAvailAble.map((item, index) => (
          <SingleAvailAbleExercise
            exercise={item}
            key={index}
            saleStep={saleStep}
            highlightedFeatures={highlightedFeatures}
          />
        ))}
      </div>
    );

  return <></>;
};

export default CalendarSaleModule;
